// extracted by mini-css-extract-plugin
module.exports = {"header":"FormulaInput_header__y_ccl","help":"FormulaInput_help__6z4kv"};